import { Reducer, Action } from 'redux';

// states
import {
  PractitionerState,
  PractitionerUnloadState
} from '../../states/PractitionerState';

// functions

// Actions
import * as Actions from '../../actions';

// models
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import { PractitionerConsumptionSyncProcess } from '../../../models/Entities/Practitioners/PractitionerConsumptionSyncProcess';
import { PractitionerConsumption } from '../../../models/Entities/Practitioners/PractitionerConsumption';
import { PractitionerMedicalInsuranceAssociation } from '../../../models/Entities/PractitionerAssociations/MedicalInsurances/PractitionerMedicalInsuranceAssociation';
import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';
import { PractitionerAssociationsMedicalService } from '../../../models/Entities/PractitionerAssociations/MedicalServices/PractitionerAssociationMedicalService';
import { PractitionerSpecialtyAssociation } from '../../../models/Entities/PractitionerAssociations/Specialties/PractitionerSpecialtyAssociation';
import { mergeSpecialties } from './PractitionerReducer.Specialties';
import { mergePractitionerList } from './PractitionerReducer.Merge';

type KnownAction =
  | Actions.Practitioner.Practitioners_GetAll_Request_Action
  | Actions.Practitioner.Practitioners_GetAll_Receive_Action
  | Actions.Practitioner.Practitioners_GetAll_Fail_Action
  | Actions.Practitioner.Practitioner_UpdateAll_Request_Action
  | Actions.Practitioner.Practitioner_UpdateAll_Receive_Action
  | Actions.Practitioner.Practitioner_UpdateAll_Fail_Action
  | Actions.Practitioner.Practitioners_GetAll_MedicalInsurances_Request_Action
  | Actions.Practitioner.Practitioners_GetAll_MedicalInsurances_Receive_Action
  | Actions.Practitioner.Practitioners_GetAll_MedicalInsurances_Fail_Action
  | Actions.Practitioner.Practitioners_Add_MedicalInsurances_Request_Action
  | Actions.Practitioner.Practitioners_Add_MedicalInsurances_Receive_Action
  | Actions.Practitioner.Practitioners_Add_MedicalInsurances_Fail_Action
  | Actions.Practitioner.Practitioners_Delete_MedicalInsurances_Request_Action
  | Actions.Practitioner.Practitioners_Delete_MedicalInsurances_Receive_Action
  | Actions.Practitioner.Practitioners_Delete_MedicalInsurances_Fail_Action
  | Actions.Practitioner.Practitioners_GetAll_ContractsAssociations_Receive_Action
 
  // associated entities
  | Actions.PractitionerMedicalInsuranceAssociations.PractitionerMedicalInsurances_ReceiveAll_Action
  | Actions.PractitionerMedicalInsuranceAssociations.PractitionerMedicalInsurances_Add_Receive_Action
  | Actions.PractitionerMedicalInsuranceAssociations.PractitionerMedicalInsurances_DeleteByMedicalInsuranceId_Receive_Action
  | Actions.PractitionerMedicalServiceAssociations.PractitionerMedicalService_ReceiveAll_Action
  | Actions.PractitionerMedicalServiceAssociations.PractitionerMedicalService_Add_Receive_Action
  | Actions.PractitionerMedicalServiceAssociations.PractitionerMedicalService_Delete_By_Id_Receive_Action
  | Actions.PractitionerMedicalServiceAssociations.PractitionerMedicalService_Delete_By_Medical_Service_Id_Receive_Action
  | Actions.PractitionerSpecialtyAssociations.PractitionerSpecialty_ReceiveAll_Action
  | Actions.PractitionerSpecialtyAssociations.PractitionerSpecialty_Associations_Receive_Action
  | Actions.Specialties.SpecialtiesGetAllSuccessAction
  | Actions.PractitionerSpecialtyAssociations.PractitionerSpecialty_Add_Receive_Action
  | Actions.PractitionerSpecialtyAssociations.PractitionerSpecialty_Delete_Receive_Action
  | Actions.PractitionerSettings.PractitionerSettings_Receive_Action
  | Actions.PractitionerSettings.PractitionerSettings_Update_Receive_Action
  | Actions.PractitionerSettings.PractitionerSettings_Add_Receive_Action
  | Actions.PractitionerContracts.PractitionerContractsGetAll_Receive_Action
  | Actions.PractitionerContracts.PractitionerContractsGetById_Receive_Action
  | Actions.PractitionerContracts.PractitionerContractsAdd_Receive_Action
  | Actions.PractitionerContracts.PractitionerContractsUpdate_Receive_Action
  | Actions.PractitionerContracts.PractitionerContractsDelete_Receive_Action
  // protocols
  | Actions.MedicalProtocols.MedicalProtocols_GetByPractitionerId_Request_Action
  | Actions.MedicalProtocols.MedicalProtocols_GetByPractitionerId_Receive_Action
  | Actions.MedicalProtocols.MedicalProtocols_GetByPractitionerId_Fail_Action
  // visitis
  | Actions.PractitionerProtocolVisits.Pratitioner_Protocol_Visits_GetAll_Request_Action
  | Actions.PractitionerProtocolVisits.Pratitioner_Protocol_Visits_GetAll_Receive_Action
  | Actions.PractitionerProtocolVisits.Pratitioner_Protocol_Visits_GetAll_Fail_Action
  // visits count
  | Actions.PractitionerProtocolVisits.Pratitioner_Protocol_VisitsCount_GetById_Request_Action
  | Actions.PractitionerProtocolVisits.Pratitioner_Protocol_VisitsCount_GetById_Receive_Action
  | Actions.PractitionerProtocolVisits.Pratitioner_Protocol_VisitsCount_GetById_Fail_Action
  // consumptions sync process
  | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetAllByPractitionerIdRequestAction
  | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetAllByPractitionerIdSuccessAction
  | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetAllByPractitionerIdFailureAction
  // consumption sync process by id
  | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetByIdRequestAction
  | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetByIdSuccessAction
  | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetByIdFailureAction
  // last consumption sync process
  | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetLastByPractitionerIdRequestAction
  | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetLastByPractitionerIdSuccessAction
  | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetLastByPractitionerIdFailureAction
  // create consumption sync process
  | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessCreateRequestAction
  | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessCreateSuccessAction
  | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessCreateFailureAction
  // consumptions
  | Actions.PractitionerConsumptions.PractitionerConsumptionGetAllByPractitionerRequestAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionGetAllByPractitionerSuccessAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionGetAllByPractitionerFailureAction
  // consumptions by id
  | Actions.PractitionerConsumptions.PractitionerConsumptionGetByIdRequestAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionGetByIdSuccessAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionGetByIdFailureAction
  // add consumption
  | Actions.PractitionerConsumptions.PractitionerConsumptionCreateRequestAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionCreateSuccessAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionCreateFailureAction
  // update consumption
  | Actions.PractitionerConsumptions.PractitionerConsumptionUpdateRequestAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionUpdateSuccessAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionUpdateFailureAction
  // delete consumption
  | Actions.PractitionerConsumptions.PractitionerConsumptionDeleteRequestAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionDeleteSuccessAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionDeleteFailureAction
  // change amount
  | Actions.PractitionerConsumptions.PractitionerConsumptionChangeAmountRequestAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionChangeAmountSuccessAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionChangeAmountFailureAction
  // change rate
  | Actions.PractitionerConsumptions.PractitionerConsumptionChangeRateRequestAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionChangeRateSuccessAction
  | Actions.PractitionerConsumptions.PractitionerConsumptionChangeRateFailureAction;

export const PractitionerReducer: Reducer<PractitionerState> = (
  state: PractitionerState | undefined,
  incomingAction: Action
): PractitionerState => {
  if (state === undefined) {
    return PractitionerUnloadState as PractitionerState;
  }

  let CurrentPractitioner: Practitioner | undefined = undefined
  let CurrentConsumption: PractitionerConsumption | undefined = undefined


  const action = incomingAction as KnownAction;

  switch (action.type) {
    case 'PRACTITIONERS_GETALL_REQUEST_ACTION':
      return {
        ...state,
        isLoadingAll: true,
        successLoadingAll: undefined,
        failOnLoadingAll: false,
        error: undefined
      };
    case 'PRACTITIONERS_GETALL_RECEIVE_ACTION': {
      const received = {
        ...state,
        isLoadingAll: false,
        successLoadingAll: true,
        failOnLoadingAll: false,
        // Identity no manda las asociaciones: se conservan las que cada practitioner ya tenía en el store.
        list: mergePractitionerList(action.practitioners, state?.list),
        error: undefined
      };
      return { ...received, list: mergeSpecialties(received.list, state.specialtyAssociations, state.specialtyDefinitions) };
    }
    case 'PRACTITIONERS_GETALL_FAIL_ACTION':
      return {
        ...state,
        isLoadingAll: false,
        successLoadingAll: false,
        failOnLoadingAll: true,
        error: action.error
      };
    case 'PRACTITIONERS_UPDATE_ALL_REQUEST_ACTION':
      return {
        ...state,
        isUpdatingAll: true,
        UpdatingAllSuccess: undefined,
        FailUpdatingAll: false,
        error: undefined
      };
    case 'PRACTITIONERS_UPDATE_ALL_RECEIVE_ACTION':
      return {
        ...state,
        isUpdatingAll: false,
        UpdatingAllSuccess: true,
        FailUpdatingAll: false,
        list: mergeSpecialties(
          mergePractitionerList(action.practitioners, state?.list),
          state.specialtyAssociations,
          state.specialtyDefinitions
        ),
        error: undefined
      };
    case 'PRACTITIONERS_UPDATE_ALL_FAIL_ACTION':
      return {
        ...state,
        isUpdatingAll: false,
        UpdatingAllSuccess: false,
        FailUpdatingAll: true,
        error: action.error
      };
    case 'PRACTITIONERS_GETALL_MEDICALINSURANCES_REQUEST_ACTION':
      return {
        ...state,
        isLoadingAllMedicalInsurances: true,
        successLoadingAllMedicalInsurance: undefined,
        failOnLoadingAllMedicalInsurances: false,
        error: undefined
      };
    case 'PRACTITIONERS_GETALL_MEDICALINSURANCES_RECEIVE_ACTION':
      return {
        ...state,
        isLoadingAllMedicalInsurances: false,
        successLoadingAllMedicalInsurance: true,
        failOnLoadingAllMedicalInsurances: false,
        medicalInsuranceAssociations: action.MedicalInsuranceAssociations,
        error: undefined
      };
    case 'PRACTITIONERS_GETALL_MEDICALINSURANCES_FAIL_ACTION':
      return {
        ...state,
        isLoadingAllMedicalInsurances: false,
        successLoadingAllMedicalInsurance: false,
        failOnLoadingAllMedicalInsurances: true,
        error: action.error
      };
    case 'PRACTITIONERS_ADD_MEDICALINSURANCES_REQUEST_ACTION':
      return {
        ...state,
        isAddingOneMedicalInsurance: true,
        successAddingOneMedicalInsurance: undefined,
        failOnAddingOneMedicalInsurance: false,
        error: undefined
      };
    case 'PRACTITIONERS_ADD_MEDICALINSURANCES_RECEIVE_ACTION':
      return {
        ...state,
        isAddingOneMedicalInsurance: false,
        successAddingOneMedicalInsurance: true,
        failOnAddingOneMedicalInsurance: false,
        medicalInsuranceAssociations: [
          ...state.medicalInsuranceAssociations,
          action.MedicalInsuranceAssociation
        ],
        error: undefined
      };
    case 'PRACTITIONERS_ADD_MEDICALINSURANCES_FAIL_ACTION':
      return {
        ...state,
        isAddingOneMedicalInsurance: false,
        successAddingOneMedicalInsurance: false,
        failOnAddingOneMedicalInsurance: true,
        error: action.error
      };
    case 'PRACTITIONERS_DELETE_MEDICALINSURANCES_REQUEST_ACTION':
      return {
        ...state,
        isDeletingOneMedicalInsurance: true,
        successDeletingOneMedicalInsurance: undefined,
        failOnDeletingOneMedicalInsurance: false,
        error: undefined
      };
    case 'PRACTITIONERS_DELETE_MEDICALINSURANCES_RECEIVE_ACTION':
      return {
        ...state,
        isDeletingOneMedicalInsurance: false,
        successDeletingOneMedicalInsurance: true,
        failOnAddingOneMedicalInsurance: false,
        medicalInsuranceAssociations: state.medicalInsuranceAssociations.filter(
          (item: PractitionerMedicalInsuranceAssociation) =>
            item.id !== action.MedicalInsuranceAssociation.id
        ),
        error: undefined
      };
    case 'PRACTITIONERS_DELETE_MEDICALINSURANCES_FAIL_ACTION':
      return {
        ...state,
        isDeletingOneMedicalInsurance: false,
        successDeletingOneMedicalInsurance: false,
        failOnDeletingOneMedicalInsurance: true,
        error: action.error
      };
    // medical insurances
    case 'PRACTITIONER_MEDICAL_INSURANCES_RECEIVE_ALL_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (item.userId === action.practitionerId) {
            return {
              ...item,
              MedicalInsuranceAssociated: action.practitionerMedicalInsurances
            };
          }
          return item;
        })
      };
    case 'PRACTITIONER_MEDICAL_INSURANCES_ADD_RECEIVE_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (
            item.userId === action.practitionerMedicalInsurance.practitionerId
          ) {
            return {
              ...item,
              MedicalInsuranceAssociated: [
                ...item.MedicalInsuranceAssociated,
                action.practitionerMedicalInsurance
              ]
            };
          }
          return item;
        })
      };
    case 'PRACTITIONER_MEDICAL_INSURANCES_DELETE_BY_MEDICALINSURANCE_ID_RECEIVE_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (item.userId === action.practitionerId) {
            return {
              ...item,
              MedicalInsuranceAssociated:
                item.MedicalInsuranceAssociated.filter(
                  (item: PractitionerMedicalInsuranceAssociation) =>
                    item.medicalInsuranceId !== action.MedicalInsuranceId
                )
            };
          }
          return item;
        })
      };
    case 'PRACTITIONER_SETTINGS_RECEIVE_ACTION':
    case 'PRACTITIONER_SETTINGS_ADD_RECEIVE_ACTION':
    case 'PRACTITIONER_SETTINGS_UPDATE_RECEIVE_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (item.userId === action.practitionerSettings.practitionerId) {
            return {
              ...item,
              Settings: action.practitionerSettings
            };
          }
          return item;
        })
      };
    case 'PRACTITIONER_MEDICAL_SERVICE_RECEIVE_ALL_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (item.userId === action.practitionerId) {
            return {
              ...item,
              MedicalServicesAssociated: action.practitionerMedicalServices
            };
          }
          return item;
        })
      };
    case 'PRACTITIONER_MEDICAL_SERVICE_ADD_RECEIVE_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (
            item.userId === action.practitionerMedicalService.practitionerId
          ) {
            return {
              ...item,
              MedicalServicesAssociated: [
                ...item.MedicalServicesAssociated,
                action.practitionerMedicalService
              ]
            };
          }
          return item;
        })
      };
    case 'PRACTITIONER_MEDICAL_SERVICE_DELETE_BY_ID_RECEIVE_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (item.userId === action.practitionerId) {
            return {
              ...item,
              MedicalServicesAssociated: item.MedicalServicesAssociated.filter(
                (item: PractitionerAssociationsMedicalService) =>
                  item.id !== action.practitionerMedicalServiceId
              )
            };
          }
          return item;
        })
      };
    case 'PRACTITIONER_MEDICAL_SERVICE_DELETE_BY_MEDICAL_SERVICE_ID_RECEIVE_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (item.userId === action.practitionerId) {
            return {
              ...item,
              MedicalServicesAssociated: item.MedicalServicesAssociated.filter(
                (item: PractitionerAssociationsMedicalService) =>
                  item.medicalServiceId !== action.MedicalServiceId
              )
            };
          }
          return item;
        })
      };
    case 'PRACTITIONER_CONTRACTS_ADD_RECEIVE_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (item.userId === action.practitionerContract.practitionerId) {
            return {
              ...item,
              ContractAssociation: action.practitionerContract
            };
          }
          return item;
        })
      };
    case 'PRACTITIONER_CONTRACTS_DELETE_RECEIVE_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (item.userId === action.practitionerId) {
            return {
              ...item,
              ContractAssociation: undefined
            };
          }
          return item;
        })
      };
    case 'PRACTITIONER_CONTRACTS_GET_ALL_RECEIVE_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (item.userId === action.practitionerId) {
            return {
              ...item,
              ContractAssociation: action.practitionerContracts
            };
          }
          return item;
        }) as Practitioner[]
      };
    case 'MEDICALPROTOCOLS_GET_BY_PRACTITIONER_ID_REQUEST_ACTION':
      var PractitionerProtocolRequest = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId
      );

      if(PractitionerProtocolRequest !== undefined){
        PractitionerProtocolRequest = {...PractitionerProtocolRequest, isLoadingProtocols: true, loadedProtocolsSuccessfully: undefined, failOnLoadProtocols: false, errorOnLoadProtocols: undefined};
      }

      return {
        ...state,
        list: PractitionerProtocolRequest ? [...state.list?.filter((practitioner: Practitioner)=> practitioner.userId !== action.practitionerId), PractitionerProtocolRequest] : state.list
         
      }
    case 'MEDICALPROTOCOLS_GET_BY_PRACTITIONER_ID_RECEIVE_ACTION':
      var PractitionerProtocolReceive = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId
      );

      if(PractitionerProtocolReceive !== undefined){
        var currentProtocols = PractitionerProtocolReceive.Protocols || [] as Protocol[];
        var incomingProtocols = action.MedicalProtocols;
        var mergeProtocols = incomingProtocols?.map((protocol: Protocol) => 
          {
            var currentProtocol = currentProtocols.find((currentProtocol: Protocol) => currentProtocol.id === protocol.id);
            if(currentProtocol !== undefined){
              return {...currentProtocol, ...protocol};
            }else{
              return protocol;
            }
          }
        );
        console.log('mergeProtocols', mergeProtocols);
        PractitionerProtocolReceive = {...PractitionerProtocolReceive, isLoadingProtocols: false, loadedProtocolsSuccessfully: true, failOnLoadProtocols: false, errorOnLoadProtocols: undefined, Protocols: mergeProtocols};
      }

      return {
        ...state,
        list: PractitionerProtocolReceive ? [...state.list?.filter((practitioner: Practitioner)=> practitioner.userId !== action.practitionerId), PractitionerProtocolReceive] : state.list
      };
    case 'MEDICALPROTOCOLS_GET_BY_PRACTITIONER_ID_FAIL_ACTION':
      var PractitionerProtocolFail = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId
      );

      if(PractitionerProtocolFail !== undefined){
        PractitionerProtocolFail = {...PractitionerProtocolFail, isLoadingProtocols: false, loadedProtocolsSuccessfully: false, failOnLoadProtocols: true, errorOnLoadProtocols: action.error};
      }

      return {
        ...state,
        list: PractitionerProtocolFail ? [...state.list?.filter((practitioner: Practitioner)=> practitioner.userId !== action.practitionerId), PractitionerProtocolFail] : state.list
      };
    case 'PRECTITIONER_PROTOCOL_VISITS_GET_ALL_REQUEST_ACTION':
      var PractitionerProtocolVisitsRequest = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId
      );

      if(PractitionerProtocolVisitsRequest !== undefined){
        PractitionerProtocolVisitsRequest = {...PractitionerProtocolVisitsRequest, isLoadingVisits: true, loadedVisitsSuccessfully: undefined, failOnLoadVisits: false, errorOnLoadVisits: undefined};
      }

      return {
        ...state,
        list: PractitionerProtocolVisitsRequest ? [...state.list?.filter((practitioner: Practitioner)=> practitioner.userId !== action.practitionerId), PractitionerProtocolVisitsRequest] : state.list
      };
    case 'PRECTITIONER_PROTOCOL_VISITS_GET_ALL_RECEIVE_ACTION':
      var PractitionerProtocolVisitsReceive = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId
      );

      if(PractitionerProtocolVisitsReceive !== undefined){
        PractitionerProtocolVisitsReceive = {...PractitionerProtocolVisitsReceive, isLoadingVisits: false, loadedVisitsSuccessfully: true, failOnLoadVisits: false, errorOnLoadVisits: undefined};
      }

      //if(action.visits?.length > 0){
        if(PractitionerProtocolVisitsReceive !== undefined){
          PractitionerProtocolVisitsReceive = {...PractitionerProtocolVisitsReceive, ProtocolVisits: [...PractitionerProtocolVisitsReceive.ProtocolVisits?.filter((visit: any) => visit.protocolId !== action.protocolId) || [], {practitionerId: action.practitionerId, protocolId: action.protocolId, visits: action.visits}]};
        }
      //}

      return {
        ...state,
        list: PractitionerProtocolVisitsReceive ? [...state.list?.filter((practitioner: Practitioner)=> practitioner.userId !== action.practitionerId), PractitionerProtocolVisitsReceive] : state.list
      };
    case 'PRECTITIONER_PROTOCOL_VISITS_GET_ALL_FAIL_ACTION':
      var PractitionerProtocolVisitsFail = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId
      );

      if(PractitionerProtocolVisitsFail !== undefined){
        PractitionerProtocolVisitsFail = {...PractitionerProtocolVisitsFail, isLoadingVisits: false, loadedVisitsSuccessfully: false, failOnLoadVisits: true, errorOnLoadVisits: action.error};
      }

      return {
        ...state,
        list: PractitionerProtocolVisitsFail ? [...state.list?.filter((practitioner: Practitioner)=> practitioner.userId !== action.practitionerId), PractitionerProtocolVisitsFail] : state.list
      };
    case 'PRACTITIONER_PROTOCOL_VISITS_COUNT_GET_BY_ID_REQUEST_ACTION':
      var PractitionerProtocolVisitsCountRequest = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId
      );

      if(PractitionerProtocolVisitsCountRequest !== undefined){
        PractitionerProtocolVisitsCountRequest = {...PractitionerProtocolVisitsCountRequest, isLoadingVisitsCount: true, loadedVisitsCountSuccessfully: undefined, failOnLoadVisitsCount: false, errorOnLoadVisitsCount: undefined};
      }

      return {
        ...state,
        list: PractitionerProtocolVisitsCountRequest ? [...state.list?.filter((practitioner: Practitioner)=> practitioner.userId !== action.practitionerId), PractitionerProtocolVisitsCountRequest] : state.list
      };
    case 'PRACTITIONER_PROTOCOL_VISITS_COUNT_GET_BY_ID_RECEIVE_ACTION':
      var PractitionerProtocolVisitsCountReceive = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId
      );
      
      if(PractitionerProtocolVisitsCountReceive) {
        PractitionerProtocolVisitsCountReceive.ProtocolVisitsCount = action.VisitsCount;
      }

      return {
        ...state,
        list: PractitionerProtocolVisitsCountReceive ? [...state.list?.filter((practitioner: Practitioner)=> practitioner.userId !== action.practitionerId), PractitionerProtocolVisitsCountReceive] : state.list
      };
    case 'PRACTITIONER_PROTOCOL_VISITS_COUNT_GET_BY_ID_FAIL_ACTION':
      var PractitionerProtocolVisitsCountFail = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId
      );

      if(PractitionerProtocolVisitsCountFail !== undefined){
        PractitionerProtocolVisitsCountFail = {...PractitionerProtocolVisitsCountFail, isLoadingVisitsCount: false, loadedVisitsCountSuccessfully: false, failOnLoadVisitsCount: true, errorOnLoadVisitsCount: action.error};
      }

      return {
        ...state,
        list: PractitionerProtocolVisitsCountFail ? [...state.list?.filter((practitioner: Practitioner)=> practitioner.userId !== action.practitionerId), PractitionerProtocolVisitsCountFail] : state.list
      };
    // consumptions sync process
    case 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETALL_BYPRACTITIONERID_REQUEST':
      
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {...CurrentPractitioner, isLoadingConsumptionsSyncProcess: true, loadedConsumptionsSyncProcessSuccessfully: undefined, failOnLoadConsumptionsSyncProcess: false, errorOnLoadConsumptionsSyncProcess: undefined};
      }

      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    case 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETALL_BYPRACTITIONERID_SUCCESS':
      
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {
          ...CurrentPractitioner, 
          isLoadingConsumptionsSyncProcess: false, 
          loadedConsumptionsSyncProcessSuccessfully: true, 
          failOnLoadConsumptionsSyncProcess: false, 
          errorOnLoadConsumptionsSyncProcess: undefined, 
          consumptionsSyncProcess: action.processes
        };
      }

      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    case 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETALL_BYPRACTITIONERID_FAILURE':
      
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {...CurrentPractitioner, isLoadingConsumptionsSyncProcess: false, loadedConsumptionsSyncProcessSuccessfully: false, failOnLoadConsumptionsSyncProcess: true, errorOnLoadConsumptionsSyncProcess: action.error};
      }
      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    // consumption sync process by id
    case 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GET_BYID_REQUEST':
      
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {...CurrentPractitioner, isLoadingConsumptionsSyncProcess: true, loadedConsumptionsSyncProcessSuccessfully: undefined, failOnLoadConsumptionsSyncProcess: false, errorOnLoadConsumptionsSyncProcess: undefined};
      }

      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    case 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GET_BYID_SUCCESS':
      
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.process.practitionerId);

      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {
          ...CurrentPractitioner, 
          isLoadingConsumptionsSyncProcess: false, 
          loadedConsumptionsSyncProcessSuccessfully: true, 
          failOnLoadConsumptionsSyncProcess: false, 
          errorOnLoadConsumptionsSyncProcess: undefined, 
          consumptionsSyncProcess: [
            ...CurrentPractitioner.consumptionsSyncProcess?.filter((item: PractitionerConsumptionSyncProcess) => 
              item.id !== action.process.id) ?? [], 
            action.process
          ]
        };
      }

      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.process.practitionerId), CurrentPractitioner!] : state.list
      };
    case 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GET_BYID_FAILURE':
      
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {...CurrentPractitioner, isLoadingConsumptionsSyncProcess: false, loadedConsumptionsSyncProcessSuccessfully: false, failOnLoadConsumptionsSyncProcess: true, errorOnLoadConsumptionsSyncProcess: action.error};
      }

      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };

    // last consumption sync process
    case 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETLAST_BYPRACTITIONERID_REQUEST':
    
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {
          ...CurrentPractitioner, 
          isLoadingLastConsumptionSyncProcess: true, 
          loadedLastConsumptionSyncProcessSuccessfully: undefined, 
          failOnLoadLastConsumptionSyncProcess: false, 
          errorOnLoadLastConsumptionSyncProcess: undefined
        };
      }

      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    case 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETLAST_BYPRACTITIONERID_SUCCESS':
      
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {
          ...CurrentPractitioner, 
          isLoadingLastConsumptionSyncProcess: false, 
          loadedLastConsumptionSyncProcessSuccessfully: true, 
          failOnLoadLastConsumptionSyncProcess: false, 
          errorOnLoadLastConsumptionSyncProcess: undefined, 
          lastConsumptionSyncProcess: action.process
        };
      }
      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    case 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETLAST_BYPRACTITIONERID_FAILURE':
        
        CurrentPractitioner = state.list.find(
          (item: Practitioner) => item.userId === action.practitionerId);
  
        if(CurrentPractitioner !== undefined){
          CurrentPractitioner = {
            ...CurrentPractitioner, 
            isLoadingLastConsumptionSyncProcess: false, 
            loadedLastConsumptionSyncProcessSuccessfully: false, 
            failOnLoadLastConsumptionSyncProcess: true, 
            errorOnLoadLastConsumptionSyncProcess: action.error
          };
        }
  
        return {
          ...state,
          list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
        };
    // create consumption sync process
    case 'PRACTITIONERCONSUMPTIONSYNCPROCESS_CREATE_REQUEST':
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {...CurrentPractitioner, isCreatingSyncProcess: true, createdSyncProcessSuccessfully: undefined, failOnCreateSyncProcess: false, errorOnCreateSyncProcess: undefined};
      }

      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    case 'PRACTITIONERCONSUMPTIONSYNCPROCESS_CREATE_SUCCESS':
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.process.practitionerId);

      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {
          ...CurrentPractitioner, 
          isCreatingSyncProcess: false,
          createdSyncProcessSuccessfully: true,
          failOnCreateSyncProcess: false,
          errorOnCreateSyncProcess: undefined,
          consumptionsSyncProcess: [
            ...CurrentPractitioner.consumptionsSyncProcess?.filter((item: PractitionerConsumptionSyncProcess) => item.id !== action.process.id) ?? [], 
            action.process
          ]
        };
      }

      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.process.practitionerId), CurrentPractitioner!] : state.list
      };
    case 'PRACTITIONERCONSUMPTIONSYNCPROCESS_CREATE_FAILURE':
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {
          ...CurrentPractitioner, 
          isCreatingSyncProcess: false, 
          createdSyncProcessSuccessfully: false, 
          failOnCreateSyncProcess: true, 
          errorOnCreateSyncProcess: action.error
        };
      }

      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };

    // consumptions
    case 'PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_REQUEST':
      
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {...CurrentPractitioner, isLoadingConsumptions: true, loadedConsumptionsSuccessfully: undefined, failOnLoadConsumptions: false, errorOnLoadConsumptions: undefined};
      }

      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    case 'PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_SUCCESS':
        CurrentPractitioner = state.list.find(
          (item: Practitioner) => item.userId === action.practitionerId);
  
        if(CurrentPractitioner !== undefined){
          CurrentPractitioner = {
            ...CurrentPractitioner, 
            isLoadingConsumptions: false, 
            loadedConsumptionsSuccessfully: true, 
            failOnLoadConsumptions: false, 
            errorOnLoadConsumptions: undefined, 
            consumptions: action.consumptions,
            consumptionPagintationState: action.paginationState
          };
        }
  
        return {
          ...state,
          list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
        };
    case 'PRACTITIONERCONSUMPTION_GETALL_BYPRACTITIONER_FAILURE':
          CurrentPractitioner = state.list.find(
            (item: Practitioner) => item.userId === action.practitionerId);
    
          if(CurrentPractitioner !== undefined){
            CurrentPractitioner = {...CurrentPractitioner, isLoadingConsumptions: false, loadedConsumptionsSuccessfully: false, failOnLoadConsumptions: true, errorOnLoadConsumptions: action.error};
          }
    
          return {
            ...state,
            list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
          };
    // consumption by id
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_GET_BYID_REQUEST:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);
      
      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {...CurrentPractitioner, isLoadingConsumptions: true, loadedConsumptionsSuccessfully: undefined, failOnLoadConsumptions: false, errorOnLoadConsumptions: undefined};
      }

      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner] : state.list
      };
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_GET_BYID_SUCCESS:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.consumption.practitionerId);
  
      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {
          ...CurrentPractitioner, 
          isLoadingConsumptions: false, 
          loadedConsumptionsSuccessfully: true, 
          failOnLoadConsumptions: false, 
          errorOnLoadConsumptions: undefined, 
          consumptions: [
            ...CurrentPractitioner.consumptions?.filter((item: PractitionerConsumption) => item.id !== action.consumption.id) ?? [], 
            action.consumption
          ]
        };
      }
      
      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.consumption.practitionerId), CurrentPractitioner] : state.list
      };
      
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_GET_BYID_FAILURE:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);
  
      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {...CurrentPractitioner, isLoadingConsumptions: false, loadedConsumptionsSuccessfully: false, failOnLoadConsumptions: true, errorOnLoadConsumptions: action.error};
      }
  
      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    // Create consumption
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_CREATE_REQUEST:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.consumption.practitionerId);
  
      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {...CurrentPractitioner, isCreatingConsumption: true, createdConsumptionSuccessfully: undefined, failOnCreateConsumption: false, errorOnCreateConsumption: undefined};
      }
  
      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.consumption.practitionerId), CurrentPractitioner!] : state.list
      };
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_CREATE_SUCCESS:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === (action.practitionerId || action.consumption?.practitionerId));
  
      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {
          ...CurrentPractitioner, 
          isCreatingConsumption: false, 
          createdConsumptionSuccessfully: true, 
          failOnCreateConsumption: false, 
          errorOnCreateConsumption: undefined, 
          consumptions: [
            ...CurrentPractitioner.consumptions?.filter((item: PractitionerConsumption) => item.id !== action.consumption.id) ?? [], 
            action.consumption
          ]
        };
      }
  
      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== CurrentPractitioner!.userId), CurrentPractitioner!] : state.list
      };
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_CREATE_FAILURE:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);
  
      if(CurrentPractitioner !== undefined){
        CurrentPractitioner = {...CurrentPractitioner, isCreatingConsumption: false, createdConsumptionSuccessfully: false, failOnCreateConsumption: true, errorOnCreateConsumption: action.error};
      }
  
      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    // update consumption
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_UPDATE_REQUEST:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.consumption.practitionerId);
  
      if(CurrentPractitioner !== undefined){
        
        CurrentConsumption = CurrentPractitioner.consumptions?.find((item: PractitionerConsumption) => item.id === action.consumption.id);
        
        if(CurrentConsumption !== undefined){
          CurrentConsumption = {...CurrentConsumption, isUpdating: true, isUpdatedSuccessfully: undefined, failOnUpdating: false, error: undefined};
          CurrentPractitioner = {...CurrentPractitioner, consumptions: [...CurrentPractitioner.consumptions?.filter((item: PractitionerConsumption) => item.id !== action.consumption.id) ?? [], CurrentConsumption]};
        }
      }
  
      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.consumption.practitionerId), CurrentPractitioner!] : state.list
      };

    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_UPDATE_SUCCESS:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.consumption.practitionerId);
  
      if(CurrentPractitioner !== undefined){
        CurrentConsumption = CurrentPractitioner.consumptions?.find((item: PractitionerConsumption) => item.id === action.consumption.id);
        
        if(CurrentConsumption !== undefined){
          CurrentConsumption = {...CurrentConsumption, isUpdating: false, isUpdatedSuccessfully: true, failOnUpdating: false, error: undefined};
          CurrentPractitioner = {...CurrentPractitioner, consumptions: [...CurrentPractitioner.consumptions?.filter((item: PractitionerConsumption) => item.id !== action.consumption.id) ?? [], CurrentConsumption]};
        }
      }
  
      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.consumption.practitionerId), CurrentPractitioner!] : state.list
      };
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_UPDATE_FAILURE:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);
  
      if(CurrentPractitioner !== undefined){
        CurrentConsumption = CurrentPractitioner.consumptions?.find((item: PractitionerConsumption) => item.id === action.consumptionId);
        
        if(CurrentConsumption !== undefined){
          CurrentConsumption = {...CurrentConsumption, isUpdating: false, isUpdatedSuccessfully: false, failOnUpdating: true, error: action.error};
          CurrentPractitioner = {...CurrentPractitioner, consumptions: [...CurrentPractitioner.consumptions?.filter((item: PractitionerConsumption) => item.id !== action.consumptionId) ?? [], CurrentConsumption]};
        }
      }
  
      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    // delete consumption
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_DELETE_REQUEST:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);
  
      if(CurrentPractitioner !== undefined){
        CurrentConsumption = CurrentPractitioner.consumptions?.find((item: PractitionerConsumption) => item.id === action.consumptionId);
        
        if(CurrentConsumption !== undefined){
          CurrentConsumption = {...CurrentConsumption, isDeleting: true, isDeletedSuccessfully: undefined, failOnDeleting: false, error: undefined};
          CurrentPractitioner = {...CurrentPractitioner, consumptions: [...CurrentPractitioner.consumptions?.filter((item: PractitionerConsumption) => item.id !== action.consumptionId) ?? [], CurrentConsumption]};
        }
      }
  
      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_DELETE_SUCCESS:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);
  
      if(CurrentPractitioner !== undefined){
        CurrentConsumption = CurrentPractitioner.consumptions?.find((item: PractitionerConsumption) => item.id === action.consumptionId);
        
        if(CurrentConsumption !== undefined){
          CurrentConsumption = {...CurrentConsumption, isDeleting: false, isDeletedSuccessfully: true, failOnDeleting: false, error: undefined};
          CurrentPractitioner = {...CurrentPractitioner, consumptions: [...CurrentPractitioner.consumptions?.filter((item: PractitionerConsumption) => item.id !== action.consumptionId) ?? [], CurrentConsumption]};
        }
      }
  
      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_DELETE_FAILURE:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);
  
      if(CurrentPractitioner !== undefined){
        CurrentConsumption = CurrentPractitioner.consumptions?.find((item: PractitionerConsumption) => item.id === action.consumptionId);
        
        if(CurrentConsumption !== undefined){
          CurrentConsumption = {...CurrentConsumption, isDeleting: false, isDeletedSuccessfully: false, failOnDeleting: true, error: action.error};
          CurrentPractitioner = {...CurrentPractitioner, consumptions: [...CurrentPractitioner.consumptions?.filter((item: PractitionerConsumption) => item.id !== action.consumptionId) ?? [], CurrentConsumption]};
        }
      }
  
      return {
        ...state,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    // change amount
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_REQUEST:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        const updatedConsumptions = (CurrentPractitioner.consumptions ?? []).map((c: PractitionerConsumption) => {
          if(c.id === action.consumptionId){
            return { ...c, isAmountChanging: true, amountChanged: false, failonAmountChange: false, ErrorOnAmountChange: undefined };
          }
          return c;
        });
        CurrentPractitioner = { ...CurrentPractitioner, consumptions: updatedConsumptions };
      }

      return { ...state, list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list };
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_SUCCESS:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        const updatedConsumptions = (CurrentPractitioner.consumptions ?? []).map((c: PractitionerConsumption) => {
          if(c.id === action.consumption.id){
            // forzamos actualización de campos monetarios en caso de que backend no los recalculó
            const newUnitAmount = action.consumption.unitAmount ?? c.unitAmount;
            const newAmount = action.consumption.amount ?? ((action.consumption.quantity && newUnitAmount) ? (newUnitAmount * action.consumption.quantity) : c.amount);
            return { 
              ...c,
              ...action.consumption,
              unitAmount: newUnitAmount,
              amount: newAmount,
              isAmountChanging: false,
              amountChanged: true,
              failonAmountChange: false,
              ErrorOnAmountChange: undefined
            } as PractitionerConsumption;
          }
          return c;
        });
        CurrentPractitioner = { ...CurrentPractitioner, consumptions: updatedConsumptions };
      }

      return { ...state, list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list };
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_CHANGE_AMOUNT_FAILURE:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        const updatedConsumptions = (CurrentPractitioner.consumptions ?? []).map((c: PractitionerConsumption) => {
          if(c.id === action.consumptionId){
            return { ...c, isAmountChanging: false, amountChanged: false, failonAmountChange: true, ErrorOnAmountChange: action.error?.ErrorMessage };
          }
          return c;
        });
        CurrentPractitioner = { ...CurrentPractitioner, consumptions: updatedConsumptions };
      }

      return { ...state, list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list };
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_CHANGE_RATE_REQUEST:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        const updatedConsumptions = (CurrentPractitioner.consumptions ?? []).map((c: PractitionerConsumption) => {
          const shouldMarkChanging = c.id === action.consumptionId || (action.applyToSettlement && action.relatedSettlementId !== undefined && c.relatedSettlementId === action.relatedSettlementId);
          if(shouldMarkChanging){
            return { ...c, isRateChanging: true, rateChanged: false, failOnRateChange: false, ErrorOnRateChange: undefined };
          }
          return c;
        });
        CurrentPractitioner = { ...CurrentPractitioner, consumptions: updatedConsumptions };
      }

      return {
        ...state,
        isChangingRate: true,
        changedRateSuccessfully: undefined,
        failedChangingRate: false,
        rateUpdateMessage: undefined,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_CHANGE_RATE_SUCCESS:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        const updatedConsumptions = (CurrentPractitioner.consumptions ?? []).map((c: PractitionerConsumption) => {
          const shouldUpdate = c.id === action.consumption.id || (action.applyToSettlement && action.relatedSettlementId !== undefined && c.relatedSettlementId === action.relatedSettlementId);
          if(shouldUpdate){
            return {
              ...c,
              ...action.consumption,
              rate: action.consumption.rate ?? action.rate,
              isRateChanging: false,
              rateChanged: true,
              failOnRateChange: false,
              ErrorOnRateChange: undefined
            } as PractitionerConsumption;
          }
          return c;
        });
        CurrentPractitioner = { ...CurrentPractitioner, consumptions: updatedConsumptions };
      }

      return {
        ...state,
        isChangingRate: false,
        changedRateSuccessfully: true,
        failedChangingRate: false,
        rateUpdateMessage: undefined,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    case Actions.PractitionerConsumptions.PRACTITIONERCONSUMPTION_CHANGE_RATE_FAILURE:
      CurrentPractitioner = state.list.find(
        (item: Practitioner) => item.userId === action.practitionerId);

      if(CurrentPractitioner !== undefined){
        const updatedConsumptions = (CurrentPractitioner.consumptions ?? []).map((c: PractitionerConsumption) => {
          const shouldFail = c.id === action.consumptionId || (action.applyToSettlement && action.relatedSettlementId !== undefined && c.relatedSettlementId === action.relatedSettlementId);
          if(shouldFail){
            return { ...c, isRateChanging: false, rateChanged: false, failOnRateChange: true, ErrorOnRateChange: action.error?.ErrorMessage };
          }
          return c;
        });
        CurrentPractitioner = { ...CurrentPractitioner, consumptions: updatedConsumptions };
      }

      return {
        ...state,
        isChangingRate: false,
        changedRateSuccessfully: false,
        failedChangingRate: true,
        rateUpdateMessage: action.error?.ErrorMessage,
        list: CurrentPractitioner ? [...(state.list ?? [])?.filter((item: Practitioner) => item.userId !== action.practitionerId), CurrentPractitioner!] : state.list
      };
    case 'PRACTITIONER_SPECIALTY_RECEIVE_ALL_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (item.userId === action.practitionerId) {
            return {
              ...item,
              SpecialtiesAssociated: action.practitionerSpecialties
            };
          }
          return item;
        })
      };
    case 'PRACTITIONER_SPECIALTY_ASSOCIATIONS_RECEIVE_ACTION':
      return {
        ...state,
        specialtyAssociations: action.associations,
        list: mergeSpecialties(state.list, action.associations, state.specialtyDefinitions)
      };
    case 'SPECIALTIES_GETALL_SUCCESS':
      return {
        ...state,
        specialtyDefinitions: action.payload,
        list: mergeSpecialties(state.list, state.specialtyAssociations, action.payload)
      };
    case 'PRACTITIONER_SPECIALTY_ADD_RECEIVE_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (item.userId === action.practitionerSpecialty.practitionerId) {
            return {
              ...item,
              SpecialtiesAssociated: [
                ...(item.SpecialtiesAssociated ?? []),
                action.practitionerSpecialty
              ]
            };
          }
          return item;
        })
      };
    case 'PRACTITIONER_SPECIALTY_DELETE_RECEIVE_ACTION':
      return {
        ...state,
        list: state.list.map((item: Practitioner) => {
          if (item.userId === action.practitionerId) {
            return {
              ...item,
              SpecialtiesAssociated: (item.SpecialtiesAssociated ?? []).filter(
                (assoc: PractitionerSpecialtyAssociation) =>
                  assoc.id !== action.practitionerSpecialtyId
              )
            };
          }
          return item;
        })
      };
    default:
      return state;
  }
};
